class Faq {
    constructor(faqItem) {
        this.faq = faqItem;
        this.faqItems = Array.from(document.querySelectorAll(`${faqItem} > .faq__item`));

        window.addEventListener('load', () => {
            this.createFaq();
        });

        window.addEventListener('resize', () => {
            this.resize();
        });
    }

    resize() {
        this.faqItems.forEach((faqItem) => {
            this.getAnswerHeight(faqItem);
        });
    }

    getAnswerHeight(faqItem) { // eslint-disable-line class-methods-use-this
        const answer = faqItem.querySelector('.faq-item__answer');
        answer.style.removeProperty('height');
        answer.style.height = `${answer.scrollHeight + 20}px`;
    }

    createFaq() {
        this.faqItems.forEach((faqItem) => {
            const question = faqItem.querySelector('.faq-item__question');
            const answer = faqItem.querySelector('.faq-item__answer');

            this.getAnswerHeight(faqItem);

            answer.style.height = `${answer.scrollHeight + 20}px`;
            faqItem.classList.remove('is-active');

            question.onclick = () => {
                faqItem.classList.toggle('is-active');
            };
        });
    }
}

export default Faq;
